import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ToastContainer } from '../shared/ToastContainer';
import { GuidePanel } from '../guide/GuidePanel';
import { useTenantStore } from '../../stores/tenantStore';
import styles from './AppShell.module.css';

export function AppShell() {
  const loadFeatures = useTenantStore((s) => s.loadFeatures);

  useEffect(() => {
    loadFeatures();
  }, [loadFeatures]);

  return (
    <div className={styles.shell}>
      <Header />
      <div className={styles.body}>
        <Sidebar />
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
      <ToastContainer />
      <GuidePanel />
    </div>
  );
}
